import { Controller } from "@hotwired/stimulus";

// Shows the detail rows whose value is currently selected in a multiselect and hides the rest, so
// a picked record previews in the read-only list before the form is saved — the same idea as
// admin--pos-price-locations, minus the price math. Every candidate row is server-rendered (hidden)
// so there's nothing to fetch client-side.
//
// Wire it on an element wrapping both the multiselect and the rows (the multiselect's bubbling
// "change" triggers #sync):
//   data-controller="admin--multiselect-rows"
//   data-admin--multiselect-rows-name-value="record[promotions]"
//   data-action="change->admin--multiselect-rows#sync"
// and tag each row with data-admin--multiselect-rows-target="row" plus
// data-row-value="<its multiselect value>". An optional "empty" target shows when nothing is
// selected.
export default class extends Controller {
  static targets = ["row", "empty"];
  static values = { name: String };

  connect() {
    this.sync();
  }

  sync() {
    const selected = this.selectedValues();
    let anyVisible = false;
    this.rowTargets.forEach((row) => {
      const show = selected.has(row.dataset.rowValue);
      row.classList.toggle("hidden", !show);
      anyVisible ||= show;
    });
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", anyVisible);
  }

  selectedValues() {
    return new Set(
      Array.from(this.element.querySelectorAll(`input[name="${this.nameValue}[]"]`))
        .map((input) => input.value)
        .filter((value) => value !== "")
    );
  }
}
